import { ApolloLink } from '@apollo/client';
import { shareAuth } from '@frameio/utils/auth';

/**
 * adds custom headers when a user is requesting data from the `share/` review
 * experience.
 *
 * share id should always be set, but passphrases are only needed if the backend
 * tells us so.
 */
export const shareReviewAuthLink = (shareId: string) => {
  return new ApolloLink((operation, forward) => {
    const passphrase = shareAuth.getPassphraseById(shareId);
    const identifiedUserSessionId = shareAuth.getIdentifiedUserSessionId();

    // Allow certain queries for Authenticated Users to bypass share auth
    const shareAuthHeader = operation?.getContext().bypassShareAuth
      ? {}
      : {
          [`${shareAuth.X_SHARE_AUTHORIZATION_HEADER}`]:
            shareAuth.encodeHeaderStringBase64(shareId, passphrase),
        };

    // Always include identifiedUserSessionIdHeader if available
    const identifiedUserSessionIdHeader = identifiedUserSessionId
      ? {
          [`${shareAuth.X_IDENTIFIED_USER_SESSION_ID_HEADER}`]:
            identifiedUserSessionId,
        }
      : {};

    operation?.setContext({
      headers: {
        ...operation?.getContext()?.headers,
        ...shareAuthHeader,
        ...identifiedUserSessionIdHeader,
      },
    });

    return forward(operation);
  });
};
